import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgIdee = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      d="M20 3.39533L18.8151 2L16.3597 3.97933L17.5446 5.37466L20 3.39533Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4616 9.85875C17.4616 12.0664 16.5674 14.0057 14.8062 15.1283V17.3743H7.31665L7.40492 15.2119C5.6437 14.0893 4.54352 12.0664 4.54352 9.85875C4.54352 6.38313 7.43534 3.56558 11.0026 3.56558C14.5698 3.56558 17.4616 6.38313 17.4616 9.85875ZM6.40224 9.85875C6.40224 11.7592 7.61616 13.3834 9.32973 14.0354L9.13547 15.5633H12.7847L12.6754 14.0354C14.389 13.3834 15.6029 11.7592 15.6029 9.85875C15.6029 7.38331 13.5433 5.37657 11.0026 5.37657C8.46188 5.37657 6.40224 7.38331 6.40224 9.85875Z"
      fill="currentColor"
    />
    <path
      d="M14.7665 18.0534H7.33157V20H14.7665V18.0534Z"
      fill="currentColor"
    />
    <path
      d="M4.34547 13.7565L5.53033 15.1518L3.27402 16.9706L2.08915 15.5753L4.34547 13.7565Z"
      fill="currentColor"
    />
    <path
      d="M16.3806 15.013L17.5654 13.6177L20 15.5802L18.8152 16.9756L16.3806 15.013Z"
      fill="currentColor"
    />
    <path
      d="M3.18486 2.01682L2 3.41215L4.43459 5.37469L5.61946 3.97936L3.18486 2.01682Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgIdee);

export default ForwardRef;
